import { ChangeDetectorRef, Component, OnInit, ViewChild, Input, ElementRef, EventEmitter, Output, inject, TemplateRef, AfterViewInit, ViewChildren, QueryList } from '@angular/core';
import { questionModel, questions, mapQuestionStudy } from 'src/models/question.model';
import { AdminService } from 'src/services/admin.service';
import { Router } from '@angular/router';
import { ConfigService } from 'src/services/config.service';
import { SelectItem } from 'primeng/api';
import { questionFilter } from 'src/app/model/gridFilter.model';
import { MessageService } from 'primeng/api';
import { NavigationTrackingService } from 'src/services/navigation-tracking.service';
import { UserPreferencesStore } from 'src/app/store/user-preferences/user-preferences.store';
import { NavigationStore } from 'src/app/store/navigation/navigation.store';
import { AuthStore } from 'src/app/store/authorization/auth.store';
import { SHARED_IMPORTS } from 'src/app/shared/shared.module';
import { DynamicTableComponent } from 'src/app/shared/dynamic-table/dynamic-table.component';
import { DynamicColumnConfig, DynamicTableConfig, DynamicTableFilter, SelectionEvent } from 'src/app/shared/dynamic-table/dynamic-table.model';
import { MultiSelect } from 'primeng/multiselect';
import { Function } from 'src/Utilities/enum';

@Component({
  selector: 'app-question-library',
  templateUrl: './question-library.component.html',
  styleUrls: ['./question-library.component.css'],
  providers: [MessageService],
  standalone: true,
  imports: [...SHARED_IMPORTS, DynamicTableComponent]
})

export class QuestionLibraryComponent implements OnInit, AfterViewInit {
  @Input() data;
  @ViewChildren('question') question: QueryList<MultiSelect>;
  @ViewChildren('tag') tag: QueryList<MultiSelect>;
  @ViewChildren('study') study: QueryList<MultiSelect>;
  @ViewChild('scrollTop', { static: true }) scrollTop: ElementRef;
  @ViewChild('dynamicTable') dynamicTable: DynamicTableComponent;
  @ViewChild('questionTextTemplate') questionTextTemplate: TemplateRef<any>;
  @ViewChild('actionsTemplate') actionsTemplate: TemplateRef<any>;
  @Output() messageToParent = new EventEmitter<string>();
  public questionList: questions[] = [];
  public filterQuestionList: questions[] = [];
  public selectedQuestionList: questions[] = [];
  public QuestionsForDeleteLibrary: questionModel = new questionModel();;
  cols: any[];
  questionSelect: SelectItem[] = [];
  tagSelect: SelectItem[] = [];
  studySelect: SelectItem[] = [];
  questionFilter: questionFilter = new questionFilter();
  questionFilterHier: string[] = [];
  _mapQuestionStudy: mapQuestionStudy = new mapQuestionStudy();
  reference_number: number = 0;
  public studyId: number = 0;
  public isQuestinLibrary: boolean;
  selectedQuestions: questions[] = [];
  isEditDisabled: boolean = false;
  showMultiDelete: boolean = true;
  public selectedQuestionIds: number[] = [];
  isFromSessionStore = false;
  selectedTag: string[] = [];
  checkedTag: string[] = [];
  selectedStudy: string[] = [];
  checkedStudy: string[] = [];
  isFirstNavigation = false;
  sessionStore: any;
  isClearQuesLibraryFilterOn = false;
  dynamicColumns: DynamicColumnConfig[] = [];
  tableConfig: DynamicTableConfig;
  cellTemplates: { [field: string]: TemplateRef<any> } = {};
  editingQuestionId: number | null = null; 

  private readonly userPreferencesStore = inject(UserPreferencesStore);
  private readonly navigationStore = inject(NavigationStore);
  private readonly authStore = inject(AuthStore);

  private deferUiUpdate(updateFn: () => void): void {
    Promise.resolve().then(() => {
      updateFn();
      this.cdr.markForCheck();
    });
  }

  constructor(private admin: AdminService, private cdr: ChangeDetectorRef) {
    this.isFirstNavigation = this.navigationStore.isFirstNavigationToQuestionLibrary();
  }

  userId: string;
  ngOnInit() {
    this.authStore.setIsAdminUser(true);
    this.studyId = this.data;
    if (this.studyId !== undefined && this.studyId !== 0 && this.studyId !== null) {
      this.isQuestinLibrary = false;
    }
    else {
      this.isQuestinLibrary = true;
    }

    this.initializeDynamicTable();

    const storedFilter = this.userPreferencesStore.questionLibrary();
    if (storedFilter && (storedFilter.tag.length > 0 || storedFilter.study.length > 0)) {
      this.questionFilter = storedFilter;
      this.isFromSessionStore = true;
      this.selectedTag = this.questionFilter.tag;
      this.selectedStudy = this.questionFilter.study;
    }
    this.getQuestionsLibrary();    
  }

  ngAfterViewInit(): void {
    this.cellTemplates = {
      question_Text: this.questionTextTemplate,
      actions: this.actionsTemplate
    };
    this.cdr.detectChanges();
  }

  private initializeDynamicTable(): void {
    const isQuestinLibrary = this.isQuestinLibrary ? 'Question Library' : 'Choose Question';
    this.tableConfig = {
      rows: 25,
      selectable: true,
      selectionMode: 'multiple',
      globalSearch: true,
      exportable: false,
      deletable: this.isQuestinLibrary ? true : false,
      lazy: false,
      dataKey: 'question_ID',
      preferenceKey: 'questionLibrary',
      supportFilterHierarchy: true,
      title: isQuestinLibrary,
      columnFilteringEnabled: false,
      addable: false,
      showPagination: true
    };

    this.dynamicColumns = [
      {
        field: 'question_Text',
        header: 'Question',
        width: this.isQuestinLibrary ? '600px' : undefined,
        sortable: true,
        filterable: false,
        customTemplate: 'question_Text'
      },
      {
        field: 'study_Tag',
        header: 'Tags',
        width: this.isQuestinLibrary ? '250px' : undefined,
        sortable: true,
        filterable: true,
        filterType: 'multiselect',
        filterField: 'study_Tag',
        filterOptions: []
      },
      {
        field: 'study_Name',
        header: 'Studies',
        width: this.isQuestinLibrary ? '225px' : undefined,
        sortable: true,
        filterable: true,
        filterType: 'multiselect',
        filterField: 'study_Name',
        filterOptions: []
      }
    ];

    if (this.isQuestinLibrary) {
      this.dynamicColumns.push({
        field: 'actions',
        header: '',
        width: '110px',
        sortable: false,
        filterable: false,
        customTemplate: 'actions'
      });
    }
  }
  get isEditable(): boolean {
    return this.authStore.isVisible(Function.EditQuestion);

  }

  onRowEditInit(question_id) {
    this.admin.getQuestionById(question_id)
      .subscribe(res => {
        this.QuestionsForDeleteLibrary = res;
      });
    this.admin.getQuestionsbyReference(question_id)
      .subscribe(res => {
        this.reference_number = res;
      });
  }

  onRowEditSave(question_id, question_text) {

    if (this.reference_number > 1) {
      if (confirm("This Question is refered more than one study . Are you sure you want to Edit the question?")) {
        this.QuestionsForDeleteLibrary.questionId = question_id;
        this.QuestionsForDeleteLibrary.questionText = question_text;
        this.admin.updateQuestion(this.QuestionsForDeleteLibrary)
          .subscribe(res => {
            alert("Question Edited Successfully.");
          });
      }
    }
    else {
      this.QuestionsForDeleteLibrary.questionId = question_id;
      this.QuestionsForDeleteLibrary.questionText = question_text;
      this.admin.updateQuestion(this.QuestionsForDeleteLibrary)
        .subscribe(res => {
          alert("Question Edited Successfully.");
        });
    }
  }

  onRowEditCancel(Qns: questions, index: number) {
    this.filterQuestionList[index].question_Text = this.QuestionsForDeleteLibrary.questionText;
  }

  getQuestionsLibrary() {
    this.admin.getQuestionsbyStudyandTag(0)
      .subscribe(res => {
        this.deferUiUpdate(() => {
          this.questionList = res;
          for (let key in this.questionList) {
            if (this.questionList.hasOwnProperty(key)) {
              if (this.questionList[key].study_Tag !== null && this.questionList[key].study_Tag !== "") {
                this.questionList[key].tag = this.questionList[key].study_Tag.split(',');
              }
              else {
                this.questionList[key].tag = ['(Blank)'];
              }
              if (this.questionList[key].study_Name !== null && this.questionList[key].study_Name !== "") {
                this.questionList[key].study = this.questionList[key].study_Name.split(',');
              }
              else {
                this.questionList[key].study = ['(Blank)'];
              }
            }
          }
          this.filterQuestionList = this.questionList.map(x => Object.assign({}, x));
          this.refreshFilterOptions(this.filterQuestionList);
          this.updateButtonState();
        });
      });
  }

  private refreshFilterOptions(source: questions[]): void {
    this.tagSelect = this.buildOptionsForField(source, 'study_Tag');
    this.studySelect = this.buildOptionsForField(source, 'study_Name');

    this.updateDynamicColumnFilterOptions('study_Tag', this.tagSelect);
    this.updateDynamicColumnFilterOptions('study_Name', this.studySelect);
  }

  private buildOptionsForField(source: questions[], field: 'study_Tag' | 'study_Name'): SelectItem[] {
    const values: string[] = [];

    source.forEach(item => {
      const rawValue = (item[field] || '').trim();
      if (!rawValue) {
        values.push('(Blank)');
        return;
      }

      rawValue.split(',').forEach(part => {
        const value = part.trim();
        if (value) {
          values.push(value);
        }
      });
    });

    values.push('(Blank)');

    const uniqueSorted = Array.from(new Set(values)).sort((a, b) => a.localeCompare(b));
    return uniqueSorted.map(value => ({ label: value, value }));
  }

  private updateDynamicColumnFilterOptions(field: string, options: SelectItem[]): void {
    const column = this.dynamicColumns.find(col => (col.filterField || col.field) === field);
    if (column) {
      column.filterOptions = options;
      this.dynamicTable?.updateColumnFilterOptions(field, options);
    }
  }

  onDynamicFilterChange(filterState: DynamicTableFilter): void {
    const selectedTags = (filterState.columnFilters?.['study_Tag'] || []) as string[];
    const selectedStudies = (filterState.columnFilters?.['study_Name'] || []) as string[];

    this.checkedTag = [...selectedTags];
    this.checkedStudy = [...selectedStudies];
    this.questionFilter.tag = [...selectedTags];
    this.questionFilter.study = [...selectedStudies];

    this.userPreferencesStore.setQuestionLibraryFilter(this.questionFilter);
  }

  onFilterOptionsRefresh(event: { field: string; currentFilters: any; hierarchy: string[] }): void {
    const tags = this.buildOptionsForField(this.questionList, 'study_Tag');
    const studies = this.buildOptionsForField(this.questionList, 'study_Name');

    this.updateDynamicColumnFilterOptions('study_Tag', tags);
    this.updateDynamicColumnFilterOptions('study_Name', studies);
  }

  onDynamicSelectionChange(event: SelectionEvent): void {
    this.selectedQuestionList = event?.selectedRows || [];
    this.updateButtonState();
  }

  onDynamicPageChange(event: any): void {
    this.paginate(event);
  }
  clearGridColumn_ClientSide(event, table, colname) {
    this.isClearQuesLibraryFilterOn = true;
    switch (colname) {
      case "tag":
        this.checkedTag = [];
        this.questionFilter.tag = [];
        break;
      case "study":
        this.checkedStudy = [];
        this.questionFilter.study = [];
        break;
    }
    this.questionFilterHier = this.questionFilterHier.filter(x => x !== colname);

    this.clearQuestionFilter_ClientSide(colname);
  }
  filterGridRecords_ClientSide(event, table, colname) {
    this.filterQuestionList = this.questionList.map(x => Object.assign({}, x));

    if (event !== null) {
      this.isFromSessionStore = false;
    }

    if (!this.questionFilterHier.includes(colname))
      this.questionFilterHier.push(colname);

    switch (colname) {
      case "tag":
        this.tag.forEach(ds => {
          if (ds.value !== undefined && ds.value !== null) {
            this.questionFilter.tag = ds.value;
            this.questionFilter.tag = [...this.questionFilter.tag, ...this.selectedTag];
          }
          ds.overlayVisible = false;
        });
        break;
      case "study":
        this.study.forEach(ds => {
          if (ds.value !== undefined && ds.value !== null) {
            this.questionFilter.study = ds.value;
            this.questionFilter.study = [...this.questionFilter.study, ...this.selectedStudy];
          }
          ds.overlayVisible = false;
        });
        break;
    }

    if (this.questionFilter.tag.length !== 0) {
      this.filterQuestionList = this.filterQuestionList.filter(data => {
        return data.tag.findIndex(ta =>
          this.questionFilter.tag.findIndex(m => m === ta) > -1) > -1
      });
    }
    if (this.questionFilter.study.length !== 0) {
      this.filterQuestionList = this.filterQuestionList.filter(data => {
        return data.study.findIndex(ta =>
          this.questionFilter.study.findIndex(m => m === ta) > -1) > -1
      });
    }
    this.userPreferencesStore.setQuestionLibraryFilter(this.questionFilter);
    this.filterQuestions_ClientSide(colname);
  }
  clearQuestionFilter_ClientSide(colname) {

    this.filterQuestionList = this.questionList.map(x => Object.assign({}, x));

    if (this.questionFilter.tag.length !== 0) {
      this.filterQuestionList = this.filterQuestionList.filter(data => {
        return data.tag.findIndex(ta =>
          this.questionFilter.tag.findIndex(m => m === ta) > -1) > -1
      });
    }
    if (this.questionFilter.study.length !== 0) {
      this.filterQuestionList = this.filterQuestionList.filter(data => {
        return data.study.findIndex(ta =>
          this.questionFilter.study.findIndex(m => m === ta) > -1) > -1
      });
    }
    this.filterQuestions_ClientSide(colname);
    this.userPreferencesStore.setQuestionLibraryFilter(this.questionFilter);
  }

  filterQuestions_ClientSide(filterFor) {

    if (this.questionFilter.tag.length === 0)
      this.tagSelect = [];
    if (this.questionFilter.study.length === 0)
      this.studySelect = [];

    let _filterQuestionList = this.filterQuestionList.map(x => Object.assign({}, x));
    let tagArray = [];
    let studyArray = [];

    for (let key in _filterQuestionList) {
      if (_filterQuestionList.hasOwnProperty(key)) {
        tagArray.push(_filterQuestionList[key].study_Tag);
        studyArray.push(_filterQuestionList[key].study_Name);

        if (_filterQuestionList[key].study_Tag !== null) {
          _filterQuestionList[key].tag = _filterQuestionList[key].study_Tag.split(',');
          if (_filterQuestionList[key].study_Tag.split(',').length >= 1) {
            for (let k = 0; k < _filterQuestionList[key].study_Tag.split(',').length; k++) {
              if (_filterQuestionList[key].study_Tag.split(',')[k] !== "" && _filterQuestionList[key].study_Tag.split(',')[k] !== null)
                this.tagSelect.push({ label: _filterQuestionList[key].study_Tag.split(',')[k], value: _filterQuestionList[key].study_Tag.split(',')[k] });
            }
          }
          else {
            if (_filterQuestionList[key].study_Tag !== "" && _filterQuestionList[key].study_Tag !== null)
              this.tagSelect.push({ label: _filterQuestionList[key].study_Tag, value: _filterQuestionList[key].study_Tag });
          }
        }

        if (_filterQuestionList[key].study_Name !== null) {
          _filterQuestionList[key].study = _filterQuestionList[key].study_Name.split(',');
          if (_filterQuestionList[key].study_Name.split(',').length >= 1) {
            for (let k = 0; k < _filterQuestionList[key].study_Name.split(',').length; k++) {
              if (_filterQuestionList[key].study_Name.split(',')[k] !== "" && _filterQuestionList[key].study_Name.split(',')[k] !== null)
                this.studySelect.push({ label: _filterQuestionList[key].study_Name.split(',')[k], value: _filterQuestionList[key].study_Name.split(',')[k] });
            }
          }
          else {
            if (_filterQuestionList[key].study_Name !== "" && _filterQuestionList[key].study_Name !== null)
              this.studySelect.push({ label: _filterQuestionList[key].study_Name, value: _filterQuestionList[key].study_Name });
          }
        }
      }
    }

    this.tagSelect.push({ label: '(Blank)', value: '(Blank)' });
    this.studySelect.push({ label: '(Blank)', value: '(Blank)' });

    this.tagSelect = Array.from(this.tagSelect.reduce((m, t) => m.set(t.label, t), new Map()).values());
    this.studySelect = Array.from(this.studySelect.reduce((m, t) => m.set(t.label, t), new Map()).values());

    this.tagSelect = this.tagSelect.sort((a, b) => a.label.localeCompare(b.label));
    this.studySelect = this.studySelect.sort((a, b) => a.label.localeCompare(b.label));

    if (this.questionFilterHier.length > 0) {
      if (this.questionFilterHier[0] === "tag") {
        this.tagSelect = [];
      }
      else if (this.questionFilterHier[0] === "study") {
        this.studySelect = [];
      }

      for (let key in this.questionList) {
        if (this.questionList.hasOwnProperty(key)) {
          if (this.questionFilterHier[0] === "tag") {
            this.questionList[key].study_Tag = this.questionList[key].study_Tag === null ? "" : this.questionList[key].study_Tag;
            if (this.questionList[key].study_Tag !== null) {
              if (this.questionList[key].study_Tag.split(',').length >= 1) {
                for (let k = 0; k < this.questionList[key].study_Tag.split(',').length; k++) {
                  if (this.questionList[key].study_Tag.split(',')[k] !== "" && this.questionList[key].study_Tag.split(',')[k] !== null)
                    this.tagSelect.push({ label: this.questionList[key].study_Tag.split(',')[k], value: this.questionList[key].study_Tag.split(',')[k] });
                }
              }
              else {
                if (this.questionList[key].study_Tag !== "" && this.questionList[key].study_Tag !== null)
                  this.tagSelect.push({ label: _filterQuestionList[key].study_Tag, value: _filterQuestionList[key].study_Tag });
              }
            }
          }
          else if (this.questionFilterHier[0] === "study") {
            this.questionList[key].study_Name = this.questionList[key].study_Name === null ? "" : this.questionList[key].study_Name;
            if (this.questionList[key].study_Name !== null) {
              if (this.questionList[key].study_Name.split(',').length >= 1) {
                for (let k = 0; k < this.questionList[key].study_Name.split(',').length; k++) {
                  if (this.questionList[key].study_Name.split(',')[k] !== "" && this.questionList[key].study_Name.split(',')[k] !== null)
                    this.studySelect.push({ label: this.questionList[key].study_Name.split(',')[k], value: this.questionList[key].study_Name.split(',')[k] });
                }
              }
              else {
                if (this.questionList[key].study_Name !== "" && this.questionList[key].study_Name !== null)
                  this.studySelect.push({ label: _filterQuestionList[key].study_Name, value: _filterQuestionList[key].study_Name });
              }
            }
          }
        }
      }

      this.tagSelect.push({ label: '(Blank)', value: '(Blank)' });
      this.studySelect.push({ label: '(Blank)', value: '(Blank)' });
      this.tagSelect = Array.from(this.tagSelect.reduce((m, t) => m.set(t.label, t), new Map()).values());
      this.studySelect = Array.from(this.studySelect.reduce((m, t) => m.set(t.label, t), new Map()).values());
      this.tagSelect = this.tagSelect.sort((a, b) => a.label.localeCompare(b.label));
      this.studySelect = this.studySelect.sort((a, b) => a.label.localeCompare(b.label));
    }

    if (!this.isClearQuesLibraryFilterOn) {
      if (this.isFromSessionStore) {
        this.checkedTag = this.selectedTag;
        this.checkedStudy = this.selectedStudy;
      } else {
        if (this.isFirstNavigation || this.sessionStore === null) {
          this.checkedTag = this.tagSelect.map(x => x.value);
          this.checkedStudy = this.studySelect.map(x => x.value);
        } else {
          this.checkedTag = this.questionFilter.tag;
          this.checkedStudy = this.questionFilter.study;
        }
      }
    }
    this.isClearQuesLibraryFilterOn = false;
    this.isFirstNavigation = false;
  }
  checkBoxClick(event, question_ID) {

    let updateItem = this.questionList.filter(x => x.question_ID === question_ID)[0];
    let index = this.questionList.indexOf(updateItem);

    this.questionList[index].checked = event.target.checked;
  }
  selectAll(event) {
    for (let i = 0; i < this.questionList.length; i++) {
      let id = "checkBox_" + this.questionList[i].question_ID;
      (<HTMLInputElement>document.getElementById(id)).checked = event.target.checked;
      this.questionList[i].checked = event.target.checked;
    }
  }
  SaveQuestions() {
    let questionId: number[] = [];
    if (this.selectedQuestionList.length === 0) {
      alert('Select atleast one question!');
      return false;
    }
    for (let i = 0; i < this.selectedQuestionList.length; i++) {
      questionId.push(this.selectedQuestionList[i].question_ID);
    }
    if (this.questionList.length > 0) {
      this._mapQuestionStudy.questionId = questionId;
      this._mapQuestionStudy.studyId = this.studyId;

      this.admin.mapQuestionstoStudy(this._mapQuestionStudy)
        .subscribe(res => {
          alert('Selected question(s) added successfully.');
          this.scrollTop.nativeElement.focus();
          this.selectedQuestionList = [];
          this.getQuestionsLibrary();
          this.messageToParent.emit("true");
        });
    }

  }
  paginate(event) {
    this.scrollTop.nativeElement.focus();
  }

  getResponseFromChild(response: string) {
    this.messageToParent.emit("true");
  }

  onRowSelect() {
    this.selectedQuestionIds = this.selectedQuestionList.map(q => q.question_ID);
    this.updateButtonState();
  }

  onRowUnselect() {
    this.selectedQuestionIds = this.selectedQuestionList.map(q => q.question_ID);
    this.updateButtonState();
  }

  updateButtonState() {
    this.selectedQuestionIds = this.selectedQuestionList.map(q => q.question_ID);
    this.isEditDisabled = this.selectedQuestionList.length > 1;
    this.showMultiDelete = this.selectedQuestionList.length < 1;
  }

  isRowEditing(question: questions): boolean {
    return this.editingQuestionId === question.question_ID;
  }

  startRowEdit(question: questions): void {
    this.editingQuestionId = question.question_ID;
    this.onRowEditInit(question.question_ID);
  }

  saveRowEdit(question: questions): void {
    this.onRowEditSave(question.question_ID, question.question_Text);
    this.editingQuestionId = null;
  }

  cancelRowEdit(question: questions, index: number): void {
    this.onRowEditCancel(question, index);
    this.editingQuestionId = null;
  }

  isQuestionSelected(question: questions): boolean {
    return this.selectedQuestionList.some(selected => selected.question_ID === question.question_ID);
  }

  isAllQuestionsSelected(): boolean {
    return !!this.filterQuestionList?.length && this.selectedQuestionList.length === this.filterQuestionList.length;
  }

  isSomeQuestionsSelected(): boolean {
    return this.selectedQuestionList.length > 0 && !this.isAllQuestionsSelected();
  }

  toggleQuestionSelection(question: questions, checked: boolean): void {
    if (checked) {
      if (!this.isQuestionSelected(question)) {
        this.selectedQuestionList = [...this.selectedQuestionList, question];
      }
    } else {
      this.selectedQuestionList = this.selectedQuestionList.filter(selected => selected.question_ID !== question.question_ID);
    }
    this.updateButtonState();
  }

  toggleAllQuestions(checked: boolean): void {
    this.selectedQuestionList = checked ? [...this.filterQuestionList] : [];
    this.updateButtonState();
  }

  isFilterAllSelected(selectedValues: any[] | null | undefined, options: SelectItem[] | null | undefined): boolean {
    if (!options || options.length === 0) {
      return false;
    }
    if (!selectedValues || selectedValues.length === 0) {
      return false;
    }

    const optionValues = options.map(option => option.value);
    return optionValues.every(value => selectedValues.includes(value));
  }

  isFilterSomeSelected(selectedValues: any[] | null | undefined, options: SelectItem[] | null | undefined): boolean {
    if (!options || options.length === 0 || !selectedValues || selectedValues.length === 0) {
      return false;
    }

    return !this.isFilterAllSelected(selectedValues, options);
  }

  toggleFilterSelectAll(checked: boolean, target: string, options: SelectItem[] | null | undefined, multiSelect?: MultiSelect): void {
    const allValues = checked && options ? options.map(option => option.value) : [];

    switch (target) {
      case 'checkedTag':
        this.checkedTag = allValues as string[];
        break;
      case 'checkedStudy':
        this.checkedStudy = allValues as string[];
        break;
    }

    if (multiSelect) {
      multiSelect.updateModel([...allValues]);
      this.cdr.detectChanges();
    }
  }

  DeleteSelectedQuestions() {
    if (confirm("Are you sure you want to delete the selected questions?")) {

      this.admin.deleteQuestions(this.selectedQuestionIds)
        .subscribe(resp => {
          this.getQuestionsLibrary();
          alert("Question Deleted Successfully.");
          this.selectedQuestionList = [];
          if (this.dynamicTable) {
            this.dynamicTable.selectedRows = [];
          }
          this.updateButtonState();
        });
    }
  }
}
